export const ADOBE_TARGET_PRESOLDEN = 'presolden';
